  document.addEventListener('DOMContentLoaded', function() {
    // 添加卡片进入动画
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, {
      threshold: 0.1
    });
    
    const productCards = document.querySelectorAll('.animate-card');
    productCards.forEach((card, index) => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(20px)';
      // card.style.transition = `opacity 0.5s ease ${index * 0.1}s, transform 0.5s ease ${index * 0.1}s`;
      card.style.transition = `opacity 0.5s ease 0.5s, transform 0.5s ease 0.5s`;
      observer.observe(card);
    });
  });